import "./App.css"
import theme from "./common/ColorPalette"
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom"

import { Diet } from "./features/diet/Diet"
import { Home } from "./features/home/Home"
import { DietTips } from "./features/diet/DietTips"
import { Bio } from "./features/bio/Bio"
import { Login } from "./features/login/Login"
import { Trainee } from "./features/trainee/Trainee"
import { Meals } from "./features/meal/Meals"
import { Meal } from "./features/meal/Meal"
import { ThemeProvider } from "@emotion/react"
import { Feedback } from "./features/feedback/Feedback"
import { OnboardingClientDashboard } from "./features/dashboard/OnboardingClientDashboard"
import { Onboarding } from "./features/user/Onboarding"
import { useSelector } from "react-redux"
import { AppShell } from "./layout/AppShell"
import { selectJWT } from "./state/user/userSlice"
import { CssBaseline } from "@mui/material"
import { PricingSection } from "./features/pricing/PricingSection"
import { RootState, store } from "./app/store"
import { useEffect } from "react"
import i18n from "./common/i18n"
import { getPersistedToken } from "./common/authStorage"


function App() {
  const jwt = useSelector(selectJWT);
  const language = useSelector((state: RootState) => state.user.language)

  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language])

  const showHeader = Boolean(jwt && jwt.trim() !== "")

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppShell showHeader={showHeader}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/user/onboarding/dashboard" element={<OnboardingClientDashboard />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/pricing" element={<PricingSection />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/user/:userId/home" element={<Home />} />
              <Route path="/user/:userId/bio" element={<Bio />} />
              <Route path="/user/:userId/diet" element={<Diet />} />
              <Route path="/user/:userId/feedback" element={<Feedback />} />
              <Route path="/user/:userId/tips" element={<DietTips />} />
              <Route path="/trainee/:traineeId" element={<Trainee />} />
              <Route path="/user/:userId/meals" element={<Meals />} />
              <Route path="/meal/:mealId" element={<Meal />} />
            </Route>
          </Routes>
        </AppShell>
      </ThemeProvider>
    </BrowserRouter>
  );
}

function ProtectedRoute() {
  const jwt = useSelector(selectJWT);
  const location = useLocation();
  const token = jwt || getPersistedToken();

  if (!token) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

const originalFetch = window.fetch;

window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const response = await originalFetch(input, init);
  const persistedToken = getPersistedToken();
  if ((response.status === 401 || response.status === 403) && persistedToken) {
    store.dispatch({ type: "user/logout" });
    window.location.replace('/');
    throw new Error(`${response.status} auth failure - Redirecting to homepage.`);
  }
  return response;
};

export default App;
